import { ITargetThreshold } from '../threshold/target-threshold';

export interface IKpiTeamThreshold {
    averageHandlingTimeSeconds: {
        Voice: number | null;
        Email: number | null;
        Chat: number | null;
        External: number | null;
    };
    handledRatio: {
        Voice: number | null;
        Email: number | null;
        Chat: number | null;
        External: number | null;
    };
}

export interface ITelXLKpiTeamThreshold {
    averageHandlingTimeSeconds: {
        voice: ITargetThreshold;
        email: ITargetThreshold;
        webchat: ITargetThreshold;
        socials: ITargetThreshold;
        average: ITargetThreshold;
    };
    handledRatio: {
        voice: number | null;
        email: number | null;
        webchat: number | null;
        socials: number | null;
    };
}

export const TelXLKpiTeamThresholdDefaultState: ITelXLKpiTeamThreshold = {
    averageHandlingTimeSeconds: {
        voice: {
            target: 0,
            low: 0,
            high: 0,
            enabled: false,
        },
        email: {
            target: 0,
            low: 0,
            high: 0,
            enabled: false,
        },
        webchat: {
            target: 0,
            low: 0,
            high: 0,
            enabled: false,
        },
        socials: {
            target: 0,
            low: 0,
            high: 0,
            enabled: false,
        },
        average: {
            target: 0,
            low: 0,
            high: 0,
            enabled: false,
        },
    },
    handledRatio: {
        voice: 0,
        email: 0,
        webchat: 0,
        socials: 0,
    },
};

export const assignKpiTeamThresholdFromLegacy = (
    legacyKpiThreshold?: IKpiTeamThreshold,
): ITelXLKpiTeamThreshold => {
    if (!legacyKpiThreshold) return TelXLKpiTeamThresholdDefaultState;

    return {
        averageHandlingTimeSeconds: {
            voice: {
                target:
                    legacyKpiThreshold.averageHandlingTimeSeconds.Voice ?? 0,
                low: legacyKpiThreshold.averageHandlingTimeSeconds.Voice ?? 0,
                high: legacyKpiThreshold.averageHandlingTimeSeconds.Voice ?? 0,
                enabled:
                    legacyKpiThreshold.averageHandlingTimeSeconds.Voice !==
                        undefined &&
                    legacyKpiThreshold.averageHandlingTimeSeconds.Voice !==
                        null,
            },
            webchat: {
                target: legacyKpiThreshold.averageHandlingTimeSeconds.Chat ?? 0,
                low: legacyKpiThreshold.averageHandlingTimeSeconds.Chat ?? 0,
                high: legacyKpiThreshold.averageHandlingTimeSeconds.Chat ?? 0,
                enabled:
                    legacyKpiThreshold.averageHandlingTimeSeconds.Chat !==
                        undefined &&
                    legacyKpiThreshold.averageHandlingTimeSeconds.Chat !== null,
            },
            email: {
                target:
                    legacyKpiThreshold.averageHandlingTimeSeconds.Email ?? 0,
                low: legacyKpiThreshold.averageHandlingTimeSeconds.Email ?? 0,
                high: legacyKpiThreshold.averageHandlingTimeSeconds.Email ?? 0,
                enabled:
                    legacyKpiThreshold.averageHandlingTimeSeconds.Email !==
                        undefined &&
                    legacyKpiThreshold.averageHandlingTimeSeconds.Email !==
                        null,
            },
            socials: {
                target:
                    legacyKpiThreshold.averageHandlingTimeSeconds.External ?? 0,
                low:
                    legacyKpiThreshold.averageHandlingTimeSeconds.External ?? 0,
                high:
                    legacyKpiThreshold.averageHandlingTimeSeconds.External ?? 0,
                enabled:
                    legacyKpiThreshold.averageHandlingTimeSeconds.External !==
                        undefined &&
                    legacyKpiThreshold.averageHandlingTimeSeconds.External !==
                        null,
            },
            average: calculateAverageFromLegacy(legacyKpiThreshold),
        },
        handledRatio: {
            voice: legacyKpiThreshold.handledRatio.Voice ?? 0,
            webchat: legacyKpiThreshold.handledRatio.Chat ?? 0,
            email: legacyKpiThreshold.handledRatio.Email ?? 0,
            socials: legacyKpiThreshold.handledRatio.External ?? 0,
        },
    };
};

const calculateAverageFromLegacy = (
    legacyKpiThreshold: IKpiTeamThreshold,
): ITargetThreshold => {
    let value = 0,
        count = 0;

    if (
        legacyKpiThreshold.averageHandlingTimeSeconds.Voice !== undefined &&
        legacyKpiThreshold.averageHandlingTimeSeconds.Voice !== null
    ) {
        value += legacyKpiThreshold.averageHandlingTimeSeconds.Voice;
        count++;
    }

    if (
        legacyKpiThreshold.averageHandlingTimeSeconds.Email !== undefined &&
        legacyKpiThreshold.averageHandlingTimeSeconds.Email !== null
    ) {
        value += legacyKpiThreshold.averageHandlingTimeSeconds.Email;
        count++;
    }

    if (
        legacyKpiThreshold.averageHandlingTimeSeconds.Chat !== undefined &&
        legacyKpiThreshold.averageHandlingTimeSeconds.Chat !== null
    ) {
        value += legacyKpiThreshold.averageHandlingTimeSeconds.Chat;
        count++;
    }

    if (
        legacyKpiThreshold.averageHandlingTimeSeconds.External !== undefined &&
        legacyKpiThreshold.averageHandlingTimeSeconds.External !== null
    ) {
        value += legacyKpiThreshold.averageHandlingTimeSeconds.External;
        count++;
    }

    if (count > 0) value /= count;

    return {
        target: Math.round(value),
        high: Math.round(value),
        low: Math.round(value),
        enabled: count > 0,
    };
};
